import { axios } from './axios';
import { endpoints } from '../constants';

export default {
  async find({ businessId }: { businessId: string }) {
    const { billingInfoUrl } = endpoints();

    try {
      const { data } = await axios.get(`${billingInfoUrl}`, {
        params: {
          businessId,
        },
      });
      return data;
    } catch (error) {
      throw new Error('Failed to fetch billing info');
    }
  },
  async create(body: { [key: string]: string | number }) {
    const { billingInfoUrl } = endpoints();

    try {
      const { data } = await axios.post(`${billingInfoUrl}`, body);
      return data;
    } catch (error) {
      throw new Error('Failed to create billing info');
    }
  },
};
